<template>
  <div class="editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-bold" variant="success"></b-icon>
          </div>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-italic" variant="success"></b-icon>
          </div>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-underline" variant="success"></b-icon>
          </div>
        </button>
      </div>
    </editor-menu-bar>
    <editor-content class="editor__content" :editor="editor" />

    <div>------------------</div>
    <div>{{myimsi}}</div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from "tiptap";

import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Strike,
  Underline,
  History,
  Placeholder,
} from "tiptap-extensions";

import CustomButton from "./CustomButton";
import { mapActions } from "vuex";
const senStore = "senStore";
export default {
  props: ["content", "func", "answer"], // answer은 문장분석에서 사용됨
  components: {
    EditorContent,

    EditorMenuBar,
  },
  computed: {
    q_type() {
      return this.$store.state.questionform.q_type;
    },
  },

  data() {
    return {
      keepInBounds: true,
      newpop: false,
      timeout: null,
      editor: new Editor({
        autoFocus: true,
        editable: true,
        //editable: false,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new CustomButton(),
        ],
        content: this.content,
      }),
      editable: false,
      myimsi:'',
    };
  },

  watch: {
    content(to, from) {
      // alert("changed contente");
      this.editor.setContent(to);
    },
  },

  beforeDestroy() {
    this.editor.destroy();
  },
  mounted() {
    let $this = this;
    clearTimeout(this.timeout);
    let std_type = this.$store.state.questionmeta.std_type;

    // console.log($this.answer.id);
    // let answer_id = this.answer.id;

    this.timeout = setTimeout(() => {
      this.editor.on("update", ({ getHTML }) => {
        let k = getHTML();
        if(k === "<p></p>")  k = "";
        if (std_type == "1") {
          $this.AC_UPDATE_TXT({
            ans: $this.answer,
            txt: k,
          });
        } else if (std_type == "2" || std_type == "3") {
          $this.$store.commit($this.func, k);
        }

        this.myimsi = k;
      });
    }, 500);
  },

  methods: {
    ...mapActions(senStore, ["AC_UPDATE_TXT"]),
    processing() {
      const { selection, state } = this.editor;
      const { from, to } = selection;
      const text = state.doc.textBetween(from, to, " ");

      // alert(this.q_type);
      if (this.q_type === "1") {
        this.$emit("processing", text);
      } else if (this.q_type === "2") {
        this.$emit("processing2", text);
      } else if (this.q_type === "3") {
        this.$emit("processing3", text);
      } else if (this.q_type === "4") {
        this.$emit("processing4", text);
      } else if(this.q_type === '5') {
          this.$emit("processing5",text);
      }
    },
    reset() {
      this.editor.setContent("");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.editor {
  position: relative;
  border: 1px solid $gray200;
  border-radius: 5px;

  &__floating-menu {
    position: absolute;
    z-index: 1;
    margin-top: -0.25rem;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
    &.is-active {
      opacity: 1;
      visibility: visible;
    }
  }
  .rdclass {
    // color: red;
    // border-bottom: 1px solid red;
    background: #ddd;
    border-radius: 4px;
    padding: 6px;
    font-size: 1em;
    font-weight: normal;
    margin-bottom: 1px;
  }
}

.editor {
  //   height: 100px;
}

.editor__content *.is-empty:nth-child(1)::before,
.editor__content *.is-empty:nth-child(2)::before {
  content: attr(data-empty-text);
  float: left;
  //   color: #c9cdd2;
  color: red;
  pointer-events: none;
  height: 0;
  font-style: italic;
}
</style>
